import { render, staticRenderFns } from "./LowSalesDialog.vue?vue&type=template&id=5a226910&scoped=true"
import script from "./LowSalesDialog.vue?vue&type=script&lang=js"
export * from "./LowSalesDialog.vue?vue&type=script&lang=js"
import style0 from "./LowSalesDialog.vue?vue&type=style&index=0&id=5a226910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a226910",
  null
  
)

export default component.exports